var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97377 14.7269C6.17508 13.4601 5 11.3673 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 11.3672 17.825 13.46 16.0264 14.7268C16.6204 14.9489 17.1973 15.2205 17.7506 15.54C19.499 16.5495 20.9507 18.0015 21.96 19.7499C22.2361 20.2283 22.0722 20.8398 21.5938 21.1159C21.1155 21.392 20.5039 21.2281 20.2278 20.7498C19.3941 19.3054 18.1948 18.1059 16.7505 17.272C15.332 16.4529 13.7263 16.0148 12.0893 15.9994C12.0596 15.9998 12.0298 16 12 16C11.9702 16 11.9405 15.9998 11.9108 15.9994C10.2739 16.0148 8.66826 16.453 7.24979 17.272C5.80552 18.1059 4.60623 19.3054 3.77249 20.7498C3.49639 21.2281 2.88481 21.392 2.4065 21.1159C1.92818 20.8398 1.76425 20.2283 2.04035 19.7499C3.04961 18.0015 4.50138 16.5495 6.24971 15.54C6.80297 15.2205 7.37976 14.9489 7.97377 14.7269ZM7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9C17 11.7337 14.8062 13.9549 12.0831 13.9993C12.0555 13.9991 12.0278 13.999 12.0002 13.999C11.9724 13.999 11.9447 13.9991 11.917 13.9993C9.19384 13.955 7 11.7337 7 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.25506e85d2b26c52c31adf73048f9fe0.svg";
export { ForwardRef as ReactComponent };